"use client"

import dynamic from "next/dynamic"
import type { GlobeResidency } from "@/components/ExploreGlobe"

// The globe pulls in Three.js — heavy and browser-only — so load it lazily,
// client-side only, and keep it off the homepage critical path.
const ExploreGlobe = dynamic(
  () => import("@/components/ExploreGlobe").then((m) => ({ default: m.ExploreGlobe })),
  {
    ssr: false,
    loading: () => (
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-sm text-[var(--muted-foreground)]">Spinning up the globe…</div>
      </div>
    ),
  },
)

export function ExploreGlobeWrapper({ residencies }: { residencies: GlobeResidency[] }) {
  return <ExploreGlobe residencies={residencies} />
}
